import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { HeadersComponent } from './headers/headers.component';
import { FootersComponent } from './footers/footers.component';
import { CalloutsComponent } from './callouts/callouts.component';
import { CustomersComponent } from './customers/customers.component';
import { ServicesComponent } from './services/services.component';
import { SlidersComponent } from './sliders/sliders.component';
import { IconsComponent } from './icons/icons.component';
import { MegaMenuComponent } from './mega-menu/mega-menu.component';
import { UserTemplateComponent } from './user-template/user-template.component';
import { GettingStartedComponent } from './getting-started/getting-started.component';
import { FeaturesComponent } from './features/features.component';
import { PreLoadersComponent } from './features/pre-loaders/pre-loaders.component';
import { ButtonsComponent } from './features/buttons/buttons.component';
import { FormElementComponent } from './features/form-element/form-element.component';
import { MessageAlertComponent } from './features/message-alert/message-alert.component';
import { TabinationComponent } from './features/tabination/tabination.component';
import { DividerComponent } from './features/divider/divider.component';
import { StepComponent } from './features/step/step.component';
import { GridComponent } from './features/grid/grid.component';
import { TypographyComponent } from './features/typography/typography.component';
import { FlagComponent } from './features/flag/flag.component';
import { RibbonComponent } from './features/ribbon/ribbon.component';
import { AccordianComponent } from './features/accordian/accordian.component';
import { PrettyCheckComponent } from './features/pretty-check/pretty-check.component';
import { HeadersStylesComponent } from './features/headers-styles/headers-styles.component';
import { BadgeComponent } from './features/badge/badge.component';
import { CardsComponent } from './features/cards/cards.component';
import { TestimonialComponent } from './features/testimonial/testimonial.component';
import { IconComponent } from './features/icon/icon.component';
import { LightSliderComponent } from './features/light-slider/light-slider.component';
import { FormComponent } from './features/form/form.component';
import { PopupComponent } from './features/popup/popup.component';
import { WowSliderComponent } from './features/wow-slider/wow-slider.component';
import { UikitCdnComponent } from './features/uikit-cdn/uikit-cdn.component';
import { TemplateDesignerComponent } from './template-designer/template-designer.component';
import { BoxModelComponent } from './features/box-model/box-model.component';
import { FancyBoxComponent } from './features/fancy-box/fancy-box.component';

export const router: Routes = [
	{ path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: 'home', component: HomeComponent },
    { path: 'headers-styles', component: HeadersStylesComponent},
    { path: 'header-generator', component: HeadersComponent },
    { path: 'footer-generator', component: FootersComponent },
    { path: 'callouts', component: CalloutsComponent },
    { path: 'customers', component: CustomersComponent },
    { path: 'services', component: ServicesComponent },
    { path: 'sliders', component: SlidersComponent },
    { path: 'icons', component: IconsComponent },
    { path: 'usertemplate', component: UserTemplateComponent },
    { path: 'mega-menu', component: MegaMenuComponent },
    { path: 'getting-started', component: GettingStartedComponent },
    { path: 'features', component: FeaturesComponent },
    { path: 'preloaders', component: PreLoadersComponent },
    { path: 'buttons', component: ButtonsComponent },
    { path: 'form-elements', component: FormElementComponent},
    { path: 'message-alert', component: MessageAlertComponent},
    { path: 'tabination', component: TabinationComponent},
    { path: 'divider', component: DividerComponent},
    { path: 'step', component: StepComponent},
    { path: 'grid', component: GridComponent},
    { path: 'typography', component: TypographyComponent},
    { path: 'flag', component: FlagComponent},
    { path: 'ribbon', component: RibbonComponent},
    { path: 'accordian', component: AccordianComponent},
    { path: 'pretty-check', component: PrettyCheckComponent},
    { path: 'badge', component: BadgeComponent},
    { path: 'cards', component: CardsComponent},
    { path: 'testimonial', component: TestimonialComponent},
    { path: 'icon', component: IconComponent},
    { path: 'light-slider', component: LightSliderComponent},
    { path: 'form', component: FormComponent},
    { path: 'popup', component: PopupComponent},
    { path: 'wow-slider', component: WowSliderComponent},
    { path: 'uikit-cdn', component: UikitCdnComponent},
    { path: 'template-designer', component: TemplateDesignerComponent},
    { path: 'box-model', component: BoxModelComponent},
    { path: 'fancy-box', component: FancyBoxComponent},

];

export const routes: ModuleWithProviders = RouterModule.forRoot(router);


// WEBPACK FOOTER //
// ./src/app/app.router.ts